<template>
  <div id="bg" ref="bg">
      <img src="posters/soon-04.jpg">
    <!-- <img v-show="VP == 11" src="posters/33948-anacreon-reconstruction-4021-dos-screenshot-title-credits.gif">
    <img v-show="VP == 10" src="posters/antiwhitewashing.png">
    <div v-show="VP == 8">
      <img class="sticker" style="top:20vh;left:15vw;" src="stickers/stickers-02.png">
    </div>
    <img v-show="VP == 1" src="posters/Giacomo_Balla,_1912,_Dynamism_of_a_Dog_on_a_Leash,_oil_on_canvas,_89.8_x_109.8_cm,_Albright-Knox_Art_Gallerykopie.jpg"> -->
  </div>
</template>

<script>
export default {
  name: "Background",
  props: ['VP']
}
</script>

<style>
#bg {
  position:absolute;
  width:100%;
  height:100%;
  background-color:black;
  background-size:cover;
  background-position: center;
  background-repeat: no-repeat;
}

img {
  width:100%;
  height:100%;
  object-fit:cover;
}

img.sticker {
  position: fixed;
  height:40%;
  width:auto;
  z-index:100;
  pointer-events: none;
}

</style>